export const ERROR_RESET_DELAY = 500;
